import { GetServerSideProps, GetServerSidePropsResult } from 'next';
import { SSRConfig } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { cleanObject } from '@/lib/utils';
import SignupFlow from '@/modules/auth/components/SignupFlow';
import Layout from '@/modules/core/components/Layout';

const SignupPage = () => (
  <div className="flex -ml-2 md:ml-0 max-w-screen ">
    <span className="m-auto">
      <SignupFlow />
    </span>
  </div>
);

export default SignupPage;

// Dynamic layout configuration
SignupPage.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};

// Server side code and i18n
export const getServerSideProps: GetServerSideProps = async ({
  locale,
}): Promise<GetServerSidePropsResult<SSRConfig>> => ({
  props: cleanObject({
    ...(await serverSideTranslations(locale || 'en')),
  }),
});
